import { Check, Copy } from "lucide-react";
import { useEffect, useState } from "react";

import { Button } from "./button";

interface Props {
  value: string;
  label?: string;
  copiedLabel?: string;
  variant?: "default" | "subtle" | "icon";
}

export function CopyButton({
  value,
  label = "Copy",
  copiedLabel = "Copied!",
  variant = "subtle",
}: Props) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const id = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(id);
  }, [copied]);

  const isIcon = variant === "icon";

  return (
    <Button
      variant={isIcon ? "subtle" : variant}
      aria-label={isIcon ? (copied ? copiedLabel : label) : undefined}
      onClick={async () => {
        await navigator.clipboard.writeText(value);
        setCopied(true);
      }}
    >
      {isIcon ? (
        copied ? (
          <Check size={16} className="text-success-foreground" />
        ) : (
          <Copy size={16} className="text-foreground" />
        )
      ) : copied ? (
        copiedLabel
      ) : (
        label
      )}
    </Button>
  );
}
